var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Button, MenuSection, Pane, AccordionSet, Accordion, Checkbox, ConfirmationModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import InternationalPrefixesDetail from "./InternationalPrefixesDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { PublisherRegistrationAgencyEnum, } from "../../types/Api";
import { useInternationalPrefixFilters } from "../../hooks/useInternationalPrefixFilters";
import { useInternationalPrefixData } from "../../hooks/useInternationalPrefixData";
import { useInternationalPrefixActions } from "../../hooks/useInternationalPrefixActions";
import { useInternationalPrefixTable } from "../../hooks/useInternationalPrefixTable";
import { usePageSize } from "../../hooks/usePageSize";
var InternationalPrefixesList = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var filtersHook = useInternationalPrefixFilters();
    var _a = usePageSize(), pageSize = _a.pageSize, createPageSizeHandler = _a.createPageSizeHandler;
    var dataHook = useInternationalPrefixData(filtersHook.filters, pageSize);
    var actionsHook = useInternationalPrefixActions();
    var columns = useInternationalPrefixTable(actionsHook.handleRowClick, actionsHook.handleDefaultAgencyChange).columns;
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleAgencyChange = function (agency) {
        dataHook.resetPageOffset();
        filtersHook.handleAgencyChange(agency);
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    return (React.createElement(React.Fragment, null,
        actionsHook.isOpen && (React.createElement(ConfirmationModal, { open: actionsHook.isOpen, heading: actionsHook.modalType === "default"
                ? formatMessage({
                    id: "ui-br-agency.international-prefix.default.modal.heading",
                })
                : formatMessage({
                    id: "ui-br-agency.international-prefix.delete.modal.heading",
                }), message: actionsHook.message, onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, actionsHook.confirmAction()];
                        case 1:
                            _a.sent();
                            dataHook.refetch();
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: actionsHook.closeModal, confirmLabel: actionsHook.modalType === "default"
                ? formatMessage({
                    id: "ui-br-agency.international-prefix.button.default",
                })
                : formatMessage({ id: "ui-br-agency.button.delete" }), cancelLabel: formatMessage({
                id: "ui-br-agency.button.cancel",
            }), buttonStyle: "primary" })),
        React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(AccordionSet, null,
                        React.createElement(Accordion, { label: formatMessage({
                                id: "ui-br-agency.internationalPrefixes.accordion.filter",
                            }), separator: false }, Object.values(PublisherRegistrationAgencyEnum).map(function (agency) { return (React.createElement(Checkbox, { key: agency, label: agency, checked: filtersHook.filters.agencies.includes(agency), onChange: function () { return handleAgencyChange(agency); } })); }))))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.international-prefix.table.title" }), paneSub: formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords }), actionMenu: function (_a) {
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                history.push("/bragency/international-prefixes/create");
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                } },
                React.createElement(TableComponent, { data: dataHook.internationalPrefixesData, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filtersHook.filterPaneIsVisible, toggleFilterPane: filtersHook.toggleFilterPane, source: dataHook.source })),
            actionsHook.selectedInternationalPrefix && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.international-prefix.detail.pane.title",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function () {
                    var _a;
                    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                return actionsHook.openConfirmModal(actionsHook.selectedInternationalPrefix);
                            }, fullWidth: true },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" })),
                        !((_a = actionsHook.selectedInternationalPrefix) === null || _a === void 0 ? void 0 : _a.defaultAgency) && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                return actionsHook.openDefaultConfirmModal(actionsHook.selectedInternationalPrefix);
                            }, fullWidth: true },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.international-prefix.button.default" })))));
                } },
                React.createElement(InternationalPrefixesDetail, { internationalPrefix: actionsHook.selectedInternationalPrefix }))))));
};
export default InternationalPrefixesList;
